import { VideocamOffOutlined } from '@mui/icons-material';
import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import { useGetCamerasListApi } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Account } from 'types/Account';
import CamerasCarousel from './CamerasCarousel';
import { useNavigate } from 'react-router-dom';

function Cameras({ accountSelected }: { accountSelected: Account }) {
  const { t } = useTranslation(['_common', 'cameras']);
  const navigate = useNavigate();
  const {
    cameras,
    loading,
    error,
    refetch: refetchCamerasList,
  } = useGetCamerasListApi({ accountSelected });

  const content = React.useMemo(() => {
    if (loading) {
      return <CamerasCarousel.Loading />;
    }
    if (cameras && cameras.length > 0) {
      return <CamerasCarousel {...{ cameras, refetchCamerasList }} />;
    }
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '300px',
          flexDirection: 'column',
        }}
      >
        <VideocamOffOutlined fontSize="large" />
        <Typography variant="subtitle2" sx={{ mt: 0.5 }}>
          {t('_common:there_is_still_nothing_here')}
        </Typography>
      </Box>
    );
  }, [t, loading, cameras, refetchCamerasList]);

  if (error) {
    throw error;
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">{t('_common:cameras')}</Typography>
        {cameras && cameras.length > 0 && (
          <Button onClick={() => navigate(`/cameras/${cameras[0].name}`)}>
            {t('cameras:see_all_cameras')}
          </Button>
        )}
      </Stack>
      {content}
    </Paper>
  );
}

export default Cameras;
